import { JxsComponent } from '@jxs/component';

const mobileMediaQuery = window.matchMedia('(max-width: 1024px)');

class JxsMegaColumnCollection extends JxsComponent {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    this._isMobile = !this.closest('jxs-mega-menu');
    if (!this._isMobile) {
      // 只在桌面端绑定该事件
      this.addEventListener('mouseenter', this.#handleMouseEnter);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('mouseenter', this.#handleMouseEnter);
  }

  toggleOpen() {
    if (this._isMobile) {
      if (this.hasAttribute('open')) {
        this.removeAttribute('open');
      } else {
        this.setAttribute('open', '');
      }
    }
  }

  #handleMouseEnter = () => {
    
    const rect = this.getBoundingClientRect();
    const panelWidth = this.refs.panel.offsetWidth;
    const viewportWidth = window.innerWidth;
    const showInLeft = (rect.right + panelWidth) > viewportWidth;

    this.setAttribute('open-pos', showInLeft ? 'left' : 'right');
  }
}
customElements.define('jxs-mega-column-collection', JxsMegaColumnCollection);

class JxsMegaColumn extends JxsComponent {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  toggleOpen() {
    if (mobileMediaQuery.matches) {
      if (this.hasAttribute('open')) {
        this.removeAttribute('open');
      } else {
        this.setAttribute('open', '');
      }
    }
  }
}
customElements.define('jxs-mega-column', JxsMegaColumn);

class JxsMegaMenu extends JxsComponent {

  #shopifyBlockSelect = event => {
    if (this === event.target || this.contains(event.target)) {
      this.setAttribute('shopify-design-select', '');
    }
  }

  #shopifyBlockDeselect = event => {
    if (this === event.target || this.contains(event.target)) {
      this.removeAttribute('shopify-design-select');
    }
  }

  constructor() {
    super();
    this._triggerName = this.getDataset('triggerName');
  }

  connectedCallback() {
    super.connectedCallback();
    if (Shopify.designMode) {
      document.addEventListener('shopify:block:load', this.#shopifyBlockSelect);
      document.addEventListener('shopify:block:select', this.#shopifyBlockSelect);
      document.addEventListener('shopify:block:deselect', this.#shopifyBlockDeselect);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (Shopify.designMode) {
      document.removeEventListener('shopify:block:load', this.#shopifyBlockSelect);
      document.removeEventListener('shopify:block:select', this.#shopifyBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.#shopifyBlockDeselect);
    }
  }

  get triggerName() {
    return this._triggerName;
  }

  getContent() {
    return this.refs.content;
  }
}
customElements.define('jxs-mega-menu', JxsMegaMenu);

class JxsMobileMegaMenu extends JxsComponent {

  constructor() {
    super();
    this._triggerName = this.getDataset('triggerName');
  }

  connectedCallback() {
    super.connectedCallback();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  get triggerName() {
    return this._triggerName;
  }

  init(menuItem, name, url) {
    this._menuItem = menuItem;
    this.refs.menuName.textContent = name;
    const menuLink = this.createMenuLink(name, url);
    const dropdown = document.createElement('div');
    dropdown.className = 'menu-lv__dropdownmenu menu-dropdown';
    dropdown.append(this);
    menuItem.innerHTML = '';
    menuItem.append(menuLink);
    menuItem.append(dropdown);
    menuItem.classList.add('jxs-mobile-mega-container');

    const desktopMega = document.querySelector(`jxs-mega-menu[data-trigger-name="${this.triggerName}"]`)
    if (desktopMega) {
      const cloneContent = desktopMega.getContent().cloneNode(true);
      this.refs.content.append(...cloneContent.children);
    }
  }

  createMenuLink(name, url) {
    const p = document.createElement('p');
    p.className = 'menu-lv-1__action list-menu__item link focus-inset menu-lv__flex menu_mobile_link';

    const a = document.createElement('a');
    a.className = 'text new-menuproducts.jpg';
    a.href = url || '#';
    a.textContent = name || '';

    const span = document.createElement('span');
    span.className = 'icon-dropdown';
    span.setAttribute('data-toggle-menu-mb', '');
    span.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret">
        <path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path>
      </svg>
    `;

    p.appendChild(a);
    p.appendChild(span);
    return p;
  }

  getContent() {
    return this.refs.content;
  }

  back() {
    this._menuItem.classList.remove('is-open');
  }

  expandFirstMegaColumn() {
    this.refs.content.querySelector('jxs-mega-column')?.setAttribute('open', '');
  }
}
customElements.define('jxs-mobile-mega-menu', JxsMobileMegaMenu);

class JxsMega extends JxsComponent {

  static MOBILE_MENU_ID = 'MenuMobileListSection-menu';

  #mutationObserver = null;

  constructor() {
    super();
    this._desktopInit = false;
    this._mobileInit = false;
  }

  connectedCallback() {
    super.connectedCallback();
    if (!Shopify.designMode) {
      this.initMega();
      this.findMobileMenuList();
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#mutationObserver?.disconnect();
  }

  initMega() {
    if (this._desktopInit) {
      return;
    }
    this._desktopInit = true;
    this.refs.megas.forEach(mega => {
      const nav = document.querySelector(`.header-navigation-wrapper nav[role="navigation"] .menu-lv-item[data-nav-name="${mega.triggerName}"]`);
      if (nav) {
        const navContent = nav.querySelector('a.menu-lv-1__action').nextElementSibling;
        if (navContent) {
          nav.replaceChild(mega, navContent);
        } else {
          nav.append(mega);
        }
        nav.classList.remove('no-megamenu');
        nav.classList.add('has-megamenu', 'dropdown');
      }
    });
  }

  initMobileMega(menuList) {
    if (this._mobileInit) {
      return;
    }
    this._mobileInit = true;
    this.#mutationObserver.disconnect();

    const tmp = {};
    for (const li of menuList.children) {
      const action = li.querySelector(':scope > .menu-lv-1__action');
      let link;
      if (action.hasAttribute('href')) {
        link = action;
      } else {
        link = action.querySelector(':scope > a');
      }
      if (link) {
        const linkText = link.textContent.replace(/[\n\r\t]+/g, '');
        tmp[linkText.toLowerCase()] = {
          item: li,
          menuName: linkText,
          url: link.getAttribute('href')
        };
      }
    };

    this.refs.mobileMegas.forEach(mega => {
      const nav = tmp[mega.triggerName.toLowerCase()];
      if (nav) {
        mega.init(nav.item, nav.menuName, nav.url);
      }
      mega.expandFirstMegaColumn();
    });
  }

  /** 移动端菜单是动态初始化的，因此需要监控相应的元素是否插入到DOM */
  findMobileMenuList() {
    const mobileMenuList = document.getElementById(JxsMega.MOBILE_MENU_ID);
    if (mobileMenuList) {
      this.initMobileMega(mobileMenuList);
    } else {
      const mobileSiteNav = document.querySelector('.site-nav-mobile.nav[data-navigation-mobile]');
      if (mobileSiteNav) {
        this.#mutationObserver = new MutationObserver((mutations) => {
          let found = false;
          for (const mutation of mutations) {
            if (mutation.type === 'childList') {
              mutation.addedNodes.forEach(node => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  // 直接检查节点本身
                  if (node.id === JxsMega.MOBILE_MENU_ID) {
                    this.initMobileMega(node);
                    found = true;
                    return;
                  }
                  
                  // 检查节点的子元素
                  const targetElement = node.querySelector('#' + JxsMega.MOBILE_MENU_ID);
                  if (targetElement) {
                    this.initMobileMega(targetElement);
                    found = true;
                    return;
                  }
                }
              });
              if (found) {
                return;
              }
              
              // 检查可能已存在于被观察容器中的目标元素
              const targetElement = document.getElementById(JxsMega.MOBILE_MENU_ID);
              if (targetElement) {
                this.initMobileMega(targetElement);
                return;
              }
            }
          }
        });
        this.#mutationObserver.observe(mobileSiteNav, {
          childList: true,
          subtree: true
        });
      }
    }
  }
}
customElements.define('jxs-mega', JxsMega);
